/**
 * UC-35: SwitchUndergroundLayer
 */
import type { UndergroundLayer } from '../../../types/underground';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { ILayerManager } from '../../domain/ports/ILayerManager';

export interface SwitchUndergroundLayerInput {
  targetLayer: UndergroundLayer;
  duration?: number;
}

export interface SwitchUndergroundLayerOutput {
  ok: boolean;
  previousLayer?: UndergroundLayer;
  targetLayer?: UndergroundLayer;
  skipped?: boolean;
  reason?: string;
}

export interface SwitchUndergroundLayerDependencies {
  layerManager: ILayerManager;
  logger?: IAppLogger;
}

export class SwitchUndergroundLayerUseCase {
  constructor(private readonly deps: SwitchUndergroundLayerDependencies) {}

  execute(input: SwitchUndergroundLayerInput): SwitchUndergroundLayerOutput {
    const previousLayer = this.deps.layerManager.getCurrentLayer();

    if (this.deps.layerManager.isTransitioning()) {
      return { ok: false, reason: 'transition_in_progress', previousLayer };
    }

    if (previousLayer === input.targetLayer) {
      return {
        ok: true,
        skipped: true,
        previousLayer,
        targetLayer: input.targetLayer,
      };
    }

    this.deps.layerManager.switchToLayer(input.targetLayer, input.duration);

    this.deps.logger?.log('debug', 'layer.switched', {
      from: previousLayer,
      to: input.targetLayer,
    });

    return {
      ok: true,
      previousLayer,
      targetLayer: input.targetLayer,
    };
  }
}